import CartModalPresenter from '@src/cart/cartModalPresenter';
import ModalLayout, {
  closeTimeoutMS,
  defaultModalStyles,
} from '@src/components/layout/modalLayout';
import PageSlugs from '@src/components/layout/pageSlugs';
import { useUser } from '@src/services/userContext';
import { Themed } from '@theme-ui/mdx';
import { navigate } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import { Loader } from 'semantic-ui-react';
import { Box, Button, Flex, Grid } from 'theme-ui';
import LineItem from './lineItem';

const cartModal = ({ materialPage }) => {
  const { t, i18n } = useTranslation();
  const [cartModalVm, setCartModalVm] = useState({});
  const [cartListVm, setCartListVm] = useState({});
  const [isLoadingPay, setIsLoadingPay] = useState();
  const cartModalPresenter = new CartModalPresenter();
  const user = useUser();

  useEffect(() => {
    const updateView = (cartModalVm) => {
      setCartModalVm(cartModalVm);
    };
    cartModalPresenter.loadModalState(updateView, i18n.language);
    return updateView;
  }, []);

  useEffect(() => {
    const updateView = (cartListVm) => {
      setCartListVm(cartListVm || {});
    };

    if (user?.email) {
      cartModalPresenter.loadCartItems(updateView, user);
    }
    return updateView;
  }, [user]);

  return (
    <ReactModal
      isOpen={cartModalVm.isOpen}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      ariaHideApp={false}
      onRequestClose={() => {
        cartModalPresenter.toggleModal();
      }}
      closeTimeoutMS={closeTimeoutMS}
      style={defaultModalStyles}
    >
      <ModalLayout>
        <Box py={4}>
          <Box
            bg="white"
            sx={{
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0px 10px 30px #0000001A',
            }}
          >
            <Box
              className="checkout-header"
              sx={{ padding: '30px', textAlign: 'center' }}
            >
              <Themed.h3 sx={{ margin: 0 }}>
                {cartListVm.title}{' '}
                <span sx={{ color: 'primary' }}>{cartListVm.titleCount}</span>
              </Themed.h3>
              <Button
                variant="empty"
                type="button"
                onClick={() => {
                  cartModalPresenter.toggleModal();
                }}
                sx={{
                  padding: '8px',
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  fontSize: '14px',
                  color: 'label',
                }}
              >
                {t('close')}
              </Button>
            </Box>

            <Box sx={{ padding: ['32px', null, null, '50px 132px'] }}>
              {cartListVm.itemsByCategory &&
                cartListVm.itemsByCategory.map(
                  ({ title, type, items, hasItems }) => (
                    <Box key={title}>
                      {hasItems && (
                        <>
                          <Themed.h5
                            sx={{
                              margin: 0,
                              paddingBottom: 2,
                            }}
                          >
                            {title}
                          </Themed.h5>
                          {items.map(({ id, vm }) => (
                            <LineItem
                              key={id}
                              id={id}
                              vm={vm}
                              type={type}
                              onRemove={(id, setIsLoadingRemove) => {
                                cartModalPresenter.removeItemFromCart({
                                  lineId: id,
                                  user,
                                  loadingCallback: setIsLoadingRemove,
                                });
                              }}
                            />
                          ))}
                        </>
                      )}
                    </Box>
                  )
                )}

              {cartListVm.showBrowseOptions && (
                <Box>
                  <Themed.h4
                    sx={{
                      textAlign: 'center',
                      marginTop: 0,
                      marginBottom: 5,
                    }}
                  >
                    {t('emptyCartMessage')}
                  </Themed.h4>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: ['column', 'row'],
                      gap: '16px',
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <Button
                        className="w-100"
                        sx={{ fontSize: [3, 4] }}
                        type="button"
                        onClick={() => {
                          cartModalPresenter.toggleModal();
                          navigate(`/${PageSlugs.teachers[i18n.language]}`);
                        }}
                      >
                        {t('findATeacher')}
                      </Button>
                    </Box>
                    {materialPage && (
                      <Box>
                        <Button
                          className="w-100"
                          sx={{ fontSize: [3, 4] }}
                          type="button"
                          onClick={() => {
                            cartModalPresenter.toggleModal();
                            navigate(`/${materialPage.slug}`);
                          }}
                        >
                          {materialPage.title}
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
            </Box>

            {cartListVm.showTotalAmounts && (
              <Box
                bg="primaryPaleBg"
                sx={{
                  padding: ['32px', null, null, '32px 132px'],
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '16px',
                }}
              >
                <Grid columns={[1, 2]}>
                  <Box>
                    <Grid columns={2}>
                      <Box sx={{ textAlign: 'right' }}>
                        <div>{t('total')}:</div>
                        <div>{t('youSave')}:</div>
                      </Box>
                      <Box>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                          }}
                        >
                          <span
                            style={{
                              textDecoration:
                                cartListVm.totalAmount !==
                                cartListVm.subtotalAmount
                                  ? 'line-through'
                                  : '',
                            }}
                          >
                            {cartListVm.subtotalAmount}
                          </span>
                          {cartListVm.totalAmount !==
                            cartListVm.subtotalAmount && (
                            <span style={{ fontWeight: 'bold' }}>
                              {cartListVm.totalAmount}{' '}
                            </span>
                          )}
                        </div>
                        <div>
                          {(
                            cartListVm.subtotalAmount.substring(
                              0,
                              cartListVm.subtotalAmount.length - 1
                            ) -
                            cartListVm.totalAmount.substring(
                              0,
                              cartListVm.totalAmount.length - 1
                            )
                          ).toFixed(2)}{' '}
                          {cartListVm.currency}
                        </div>
                      </Box>
                    </Grid>
                  </Box>

                  <Flex
                    sx={{
                      flexDirection: ['row', 'column'],
                      gap: '8px',
                    }}
                  >
                    <Button
                      sx={{ borderColor: 'primary' }}
                      variant="inverted"
                      type="button"
                      onClick={() => {
                        cartModalPresenter.toggleModal();
                      }}
                    >
                      {t('continueBrowsing')}
                    </Button>

                    <Button
                      disabled={isLoadingPay}
                      type="button"
                      onClick={() => {
                        setIsLoadingPay(true);
                        cartModalPresenter.openCheckout(user, setIsLoadingPay);
                      }}
                    >
                      {isLoadingPay && (
                        <Loader inline active size="small" inverted />
                      )}
                      {!isLoadingPay && t('pay')}
                    </Button>
                  </Flex>
                </Grid>
              </Box>
            )}
          </Box>
        </Box>
      </ModalLayout>
    </ReactModal>
  );
};

export default cartModal;
